export const build = (config) => {
    const provider = window.PSGames &&
    window.PSGames.launchParams &&
    window.PSGames.launchParams.provider ?
    window.PSGames.launchParams.provider :
    config.provider;

    let selectedConfig = config[`${provider}Config`];

    if (selectedConfig) {
        selectedConfig = Object.assign({}, config, selectedConfig);
    } else {
        selectedConfig = Object.assign({}, config);
    }
    /**
     * Generate token if it is unset
     */
    if (!selectedConfig.token || !selectedConfig.token.length) {
        selectedConfig.token = Math.floor(Math.random() * 1000000).toString();
    }

    if (selectedConfig.localEngineWrapper) {
        selectedConfig.engineWrapperURL = 'http://localhost:4000/engine.js';
    } else if (selectedConfig.customEngineWrapper && selectedConfig.customEngineWrapper.length) {
        selectedConfig.engineWrapperURL = selectedConfig.customEngineWrapper;
    } else {
        // eslint-disable-next-line max-len
        selectedConfig.engineWrapperURL = `https://clients.peterandsons.org/${selectedConfig.provider}-engine-wrapper/${selectedConfig.engineWrapperVersion}/engine.js`;
    }

    if (selectedConfig.localGameExtension) {
        selectedConfig.gameExtensionURL = 'http://localhost:4001/engine-extensions.js';
    } else if (selectedConfig.customGameExtension && selectedConfig.customGameExtension.length) {
        selectedConfig.gameExtensionURL = selectedConfig.customGameExtension;
    } else {
        // eslint-disable-next-line max-len
        selectedConfig.gameExtensionURL = `https://clients.peterandsons.org/${selectedConfig.extensionName}-${selectedConfig.provider}-extensions/${selectedConfig.extensionVersion}/engine-extensions.js`;
    }

    selectedConfig.cheatConfig = config.cheatConfig;

    if (selectedConfig.cheatConfig && selectedConfig.cheats) {
        selectedConfig.cheatConfig.cheats = selectedConfig.cheats;
        selectedConfig.cheats = null;
    }

    return selectedConfig;
};
